var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgIcShieldReportFill = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M20 4.7c-.9-.9-7-2.9-8-2.9-1.1 0-7.1 2-8 2.9-.8.7-.8 1.3-.7 3.9v4.3c0 7.1 8 9.6 8.4 9.7h.6c.3-.1 8.4-2.6 8.4-9.7V8.6c0-2.6.1-3.2-.7-3.9m-9 3.5c0-.6.4-1 1-1s1 .4 1 1v4.4c0 .6-.4 1-1 1s-1-.4-1-1zm1 8.8c-.7 0-1.3-.6-1.3-1.2s.6-1.2 1.2-1.2c.7 0 1.2.6 1.2 1.2S12.7 17 12 17"
})));
export default SvgIcShieldReportFill;